import * as React from "react";
import { observer, inject } from "mobx-react";
import { RouterStore } from "mobx-react-router";
import AccountService from "../../service/AccountService";
import FileService from "../../service/FileService";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Menu,
  MenuItem,
  Input,
  Box,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { styled } from "@mui/material/styles";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LogoutButton from "../common/LogoutButton";
import autobind from "autobind-decorator";
import { observable } from "mobx";
import SaveButton from "../editor/SaveButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import MailIcon from "@mui/icons-material/Mail";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import CustomerContact from "./CustomerContact";
import { withStyles } from "@mui/styles";
import CustomLinkify from "../questionnaire/components/CustomLinkify";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import UpdateIcon from "@mui/icons-material/Update";

const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
});

const LoaderContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "center",
});

const EditIconBtn = withStyles({
  root: {
    color: "#FFF",
  },
})(IconButton);

const MobileHideDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  "@media screen and (max-width: 900px)": {
    display: "none",
  },
});
const BrowserHideDiv = styled("div")({
  "@media screen and (min-width: 900px)": {
    display: "none",
  },
});
const NavButton = withStyles({
  label: {
    color: "#FFF",
  },
})(Button);

const ChatContainer = styled("div")({
  display: "flex",
  backgroundColor: "#fff",
  height: "calc(100% - 48px)",
});

const ChatLeft = styled("div")({
  display: "flex",
  flexDirection: "column",
  flex: "0.45",
  height: "100%",
  borderRight: "1px solid lightgray",
});

const ChatRight = styled("div")({
  display: "flex",
  flexDirection: "column",
  flex: "1",
  height: "100%",
  position: "relative",
});

const ChatContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  flex: "1",
  height: "100%",
  padding: "0.7rem 0 3.5rem",
  overflowY: "auto",
});

const ChatFoot = styled("div")({
  width: "90%",
  height: "45px",
  backgroundColor: "#fff",
  color: "#5B5D65",
  alignContent: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "row",
  border: "1px solid lightgray",
  borderRadius: "4px",
  alignSelf: "center",
  padding: "0.7rem 1rem",
  margin: "0.7rem 0",
  position: "absolute",
});

const SearchBox = styled("div")({
  width: "90%",
  height: "45px",
  backgroundColor: "#fff",
  color: "#5B5D65",
  alignContent: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "row",
  border: "1px solid lightgray",
  borderRadius: "4px",
  alignSelf: "center",
  padding: "0.7rem 1rem",
  margin: "0.7rem 0",
});

type WebChatProps = {
  routing?: RouterStore;
  account?: AccountService;
  files?: FileService;
  match?: any;
};

type EditorPageStatus = "LOADING" | "NORMAL";

@inject("account")
@inject("routing")
@inject("files")
@observer
export default class WebChat extends React.Component<WebChatProps> {
  @observable
  private _status: EditorPageStatus = "LOADING";

  @observable
  private _fileName = "";

  @observable
  private anchorElMain = null;

  @observable
  private anchorElPreview = null;

  @observable
  private fileId = null;

  @observable
  private isShareDialog: boolean = false;

  @autobind
  goBack() {
    var { account } = this.props;
    this.saveData();
    account.goBack();
  }

  @autobind
  gotoPlan() {
    var { routing } = this.props;
    routing.push(`/plan`);
  }

  handleMoreClick(event: React.MouseEvent<HTMLButtonElement>) {
    this.anchorElMain = event.currentTarget;
  }

  @autobind
  handleMoreClose() {
    this.anchorElMain = null;
  }
  handlePreviewMoreClick(event: React.MouseEvent<HTMLButtonElement>) {
    this.anchorElPreview = event.currentTarget;
  }

  @autobind
  handlePreviewMoreClose() {
    this.anchorElPreview = null;
  }

  @autobind
  gotoNarratives() {
    var { routing } = this.props;
    routing.push(`/narratives/${this.fileId}`);
  }

  getSurveyLink() {
    var { account } = this.props;
    if (account.user?.uid) {
      return `/questionnaire/${account.user.uid}/${account.currentClinic}/${this.fileId}`;
    } else {
      return "/";
    }
  }

  @autobind
  async gotoQuestionnaire() {
    var { routing } = this.props;
    await this.saveData();
    routing.push(this.getSurveyLink());
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    const { routing, files } = this.props;
    this.fileId = id;
    if (id == null) {
      routing.replace("/");
      return;
    }

    this._status = "LOADING";

    var fileData = await files.loadFileData(id);
    var fileName = await files.loadFileName(id);

    if (fileData == "UNKNOWN_ERROR" || fileName == "UNKNOWN_ERROR") {
      routing.replace("/");
      return;
    }

    this._fileName = fileName;

    this._status = "NORMAL";

    window.onbeforeunload = function () {
      return null;
      //return "Changes you made may not be saved. Are you sure?";
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  @autobind
  async saveData(event: any = null): Promise<void> {
    if (event != null) {
      event.preventDefault();
    }
    let { files } = this.props;
    const { id } = this.props.match.params;
  }

  @autobind
  async openShareDialog() {
    await this.saveData();
    this.isShareDialog = true;
  }

  renderNavBar() {
    var userType = this.props.account.userData.userType;
    const userData = this.props.account.userData;

    return (
      <AppBar position="static">
        <Toolbar variant="dense">
          <SaveButton handleSave={this.saveData} kind="back" />
          <Typography variant="h6" style={{ flexGrow: 1, color: "inherit" }}>
            Web to SMS
          </Typography>

          <BrowserHideDiv>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={(e) => this.handleMoreClick(e)}
            >
              <MoreVertIcon style={{ color: "#FFF" }} />
            </IconButton>
            <Menu
              id="main-menu"
              anchorEl={this.anchorElMain}
              keepMounted
              open={Boolean(this.anchorElMain)}
              onClose={this.handleMoreClose}
            >
              <MenuItem
                style={{ padding: "6px 0px" }}
                onClick={this.handleMoreClose}
              >
                <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                  <VisibilityIcon style={{ marginRight: "10px" }} /> PREVIEW
                </Button>
              </MenuItem>
              <MenuItem
                style={{ padding: "6px 0px" }}
                onClick={this.handleMoreClose}
              >
                <Button
                  style={{ width: "100%", justifyContent: "flex-start" }}
                  onClick={this.gotoQuestionnaire}
                >
                  <i
                    className="material-icons"
                    style={{ transform: "scale(1.2)", marginRight: "10px" }}
                  >
                    {" "}
                    play_arrow{" "}
                  </i>
                  PLAY FOR RESPONDENT
                </Button>
              </MenuItem>
              <MenuItem
                style={{ padding: "6px 0px" }}
                onClick={this.handleMoreClose}
              >
                <Button
                  style={{ width: "100%", justifyContent: "flex-start" }}
                  onClick={this.gotoNarratives}
                >
                  <MailIcon style={{ marginRight: "10px" }} />
                  VIEW CHAT
                </Button>
              </MenuItem>
              <MenuItem
                style={{ padding: "6px 0px", color: "#000" }}
                onClick={this.handleMoreClose}
              >
                <SaveButton
                  handleSave={this.saveData}
                  kind="save"
                  color="#000"
                />
              </MenuItem>
              <MenuItem
                style={{ padding: "6px 0px" }}
                onClick={this.handleMoreClose}
              >
                <LogoutButton view="EDIT" />
              </MenuItem>
            </Menu>
          </BrowserHideDiv>

          <MobileHideDiv>
            {userType == "FREE_USER" && userData?.freeTrialStartDate && (
              <NavButton
                aria-label="menu"
                onClick={this.gotoPlan}
                color="inherit"
                style={{
                  color: "#fffd02",
                }}
              >
                <RunningWithErrorsIcon style={{ marginRight: "10px" }} />
                Trial: 5 days left. Upgrade now!
              </NavButton>
            )}
            {userType == "FREE_USER" && !userData?.freeTrialStartDate && (
              <NavButton
                aria-label="menu"
                onClick={this.gotoPlan}
                color="inherit"
                style={{
                  color: "#fffd02",
                }}
              >
                <UpdateIcon style={{ marginRight: "10px" }} />
                START FREE TRIAL
              </NavButton>
            )}
            {userType == "FREE_USER" && (
              <NavButton aria-label="menu" onClick={this.gotoPlan}>
                <UnarchiveIcon style={{ marginRight: "10px" }} />
                UPGRADE
              </NavButton>
            )}
            <NavButton
              style={{ justifyContent: "flex-start" }}
              onClick={(e) => this.handlePreviewMoreClick(e)}
            >
              <VisibilityIcon style={{ marginRight: "10px" }} /> PREVIEW
            </NavButton>
            <Menu
              id="preview-menu"
              anchorEl={this.anchorElPreview}
              keepMounted
              open={Boolean(this.anchorElPreview)}
              onClose={this.handlePreviewMoreClose}
            >
              <MenuItem
                style={{ padding: "6px 0px" }}
                onClick={this.handlePreviewMoreClose}
              >
                <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                  <VisibilityIcon style={{ marginRight: "10px" }} /> PREVIEW
                  FROM BEGINNING{" "}
                </Button>
              </MenuItem>
              <MenuItem
                style={{ padding: "6px 0px" }}
                onClick={this.handlePreviewMoreClose}
              >
                <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                  <VisibilityIcon style={{ marginRight: "10px" }} /> PREVIEW
                  FROM SELECTED QUESTION
                </Button>
              </MenuItem>
            </Menu>
            <NavButton
              style={{ justifyContent: "flex-start" }}
              onClick={this.openShareDialog}
            >
              <PlayArrowIcon
                style={{ transform: "scale(1.2)", marginRight: "10px" }}
              />
              SHARE
            </NavButton>
            <NavButton
              style={{ justifyContent: "flex-start" }}
              onClick={this.gotoNarratives}
            >
              <ForumRoundedIcon style={{ marginRight: "10px" }} />
              VIEW CHAT
            </NavButton>
            <SaveButton handleSave={this.saveData} kind="save" />
            <LogoutButton />
          </MobileHideDiv>
        </Toolbar>
      </AppBar>
    );
  }

  renderOwnerMessage(message: string, replyOptions?) {
    return (
      <Box
        width="70%"
        padding="4px 20px"
        paddingLeft="0"
        display="flex"
        flexDirection="row"
        alignItems="center"
      >
        <Box
          className="containerWithLink"
          bgcolor="#E9EEF3"
          borderRadius="20px 20px 20px 0"
          color="#5B5D65"
          textAlign="left"
          alignContent="center"
          margin="0px 6px"
          maxWidth="80%"
          padding="10px 20px"
          fontSize="12px"
        >
          <CustomLinkify str={message} />
        </Box>
      </Box>
    );
  }

  renderCustomerMessage(message: string, replyOptions?) {
    return (
      <>
        {message && (
          <Box
            width="70%"
            padding="4px 20px"
            paddingRight="0"
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
            alignSelf="flex-end"
          >
            <Box
              bgcolor="#1C8EFF"
              borderRadius="20px 20px 0 20px"
              color="#F9FCFF"
              display="flex"
              textAlign="left"
              alignContent="center"
              padding="10px 20px"
              margin="0px 6px"
              fontSize="12px"
              className="containerWithSimpleLink"
            >
              {message}
            </Box>
          </Box>
        )}
      </>
    );
  }

  render() {
    return (
      <Root>
        {/* header */}
        {this.renderNavBar()}
        {/* main chat */}
        <ChatContainer>
          <ChatLeft>
            <SearchBox>
              <Input
                value=""
                // onChange={(ev) => (this._qAnswer = ev.target.value)}
                // onKeyDown={this.handleKeyPress}
                disableUnderline={true}
                placeholder="Search for a client"
                style={{
                  // color: "#FFF",
                  color: "#5B5D65",
                  display: "flex",
                  flexGrow: 1,
                  fontSize: "14px",
                }}
              />
              <IconButton style={{ padding: "0 3px" }}>
                <SearchRoundedIcon style={{ color: "#5B5D65" }} />
              </IconButton>
            </SearchBox>
            <Box>
              <CustomerContact
                name="visitor"
                lastMessage="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet"
                date="12 Avril 2021"
                type="send"
              />
              <CustomerContact
                name="visitor"
                lastMessage="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet"
                date="12 Avril 2021"
                type="receive"
              />
              <CustomerContact
                name="visitor"
                lastMessage="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet"
                date="12 Mars 2021"
                type="send"
              />
              <CustomerContact
                name="visitor"
                lastMessage="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet"
                date="12 Mars 2021"
                type="receive"
              />
              <CustomerContact
                name="visitor"
                lastMessage="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet"
                date="12 Mars 2021"
                type="send"
              />
            </Box>
          </ChatLeft>
          <ChatRight>
            <Typography
              variant="h5"
              style={{
                padding: "0.7rem 1rem",
                borderBottom: "1px solid lightgray",
                position: "relative",
              }}
            >
              Username
            </Typography>
            <ChatContent className="chatContent__hideScroll">
              {this.renderOwnerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderCustomerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderOwnerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderCustomerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderOwnerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderCustomerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderOwnerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderCustomerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderOwnerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderCustomerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderOwnerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderCustomerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderOwnerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              {this.renderCustomerMessage(
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam, obcaecati nisi eum quae ipsa laudantium! Non sint hic dolorum rerum rem eveniet, fuga nostrum nisi earum, in veniam, magni nesciunt?"
              )}
              <ChatFoot style={{ bottom: "0", position: "absolute" }}>
                <Input
                  value=""
                  // onChange={(ev) => (this._qAnswer = ev.target.value)}
                  // onKeyDown={this.handleKeyPress}
                  disableUnderline={true}
                  placeholder="Type your message here"
                  style={{
                    // color: "#FFF",
                    color: "#5B5D65",
                    display: "flex",
                    flexGrow: 1,
                    fontSize: "14px",
                  }}
                />
                <IconButton style={{ padding: "0 3px" }}>
                  <SendIcon style={{ color: "#5B5D65" }} />
                </IconButton>
              </ChatFoot>
            </ChatContent>
          </ChatRight>
        </ChatContainer>
        {/* chat header */}
        {/* leftSide */}
        {/* customers container */}
        {/* customer component */}
        {/* rightSide */}
        {/* chat */}
        {/* left message */}
        {/* right message */}
        {/* send */}
      </Root>
    );
  }
}
